//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SiteStopDrawer from "./modules/SiteStopDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { queryUserTreeList as _queryUserTreeList } from '@/api/api';
import { downloadFile } from '@/api/manage';
export default {
  name: 'SiteStopList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {
    SiteStopDrawer: SiteStopDrawer
  },
  data: function data() {
    return {
      pagePath: '/om/site/stop',
      pageTitle: '停运申请',
      isorter: {
        column: 'create_time',
        order: 'desc'
      },
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点名称',
        align: 'center',
        sorter: true
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: 'rowIndex',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'userId_userName',
        colName: 'userId',
        title: '申请人员',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'stopReason_dictText',
        colName: 'stopReason',
        title: '停运原因',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'instrument',
        colName: 'instrument',
        title: '仪器型号',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'title',
        colName: 'title',
        title: '停运标题',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'stopTime',
        colName: 'stopTime',
        title: '停运时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'estimatedTime',
        colName: 'estimatedTime',
        title: '预计恢复时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'nextStatus',
        colName: 'nextStatus',
        title: '当前审批状态',
        align: 'center',
        scopedSlots: {
          customRender: 'nextStatus'
        }
      }, {
        dataIndex: 'status_dictText',
        colName: 'status_dictText',
        title: '停运状态',
        align: 'center',
        sorter: true
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      addDisabled: false,
      userTree: []
    };
  },
  created: function created() {
    this.queryUserTreeList();
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      console.log('value11', value);
      var ids = this.getTreeCurrentId();
      console.log(value);
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];

      if (ids[0] == 1) {
        // 根据站点id
        this.addDisabled = false;
        this.queryParam.siteId = ids[1];
        console.log('this.siteColumn', this.siteColumn);
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        this.addDisabled = true;
        this.queryParam.siteId = undefined;
        this.spliceColumn(this.siteColumn, 1);
      }

      this.delayLoadData();
    }
  },
  computed: {},
  methods: {
    onDateStopTime: function onDateStopTime(value, dateArray) {
      this.queryParam.timeStart = dateArray[0];
      this.queryParam.timeEnd = dateArray[1];
    },
    onDateEstimatedTime: function onDateEstimatedTime(value, dateArray) {
      this.queryParam.estimatedStart = dateArray[0];
      this.queryParam.estimatedEnd = dateArray[1];
    },
    // handleAdd: function () {
    //   let siteId = this.queryParam.siteId
    //   this.$refs.modalForm.add(siteId)
    //   this.$refs.modalForm.title = '新增：' + this.pageTitle
    //   this.$refs.modalForm.disableSubmit = false
    // },
    // 获取运维人员树
    queryUserTreeList: function queryUserTreeList() {
      var that = this;
      that.userTree = []; // 用户

      _queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }
        }
      });
    },
    onToPdf: function onToPdf(record) {
      console.log('record', record);
      downloadFile(record.siteName + '停运申请.pdf', window.domainURL + '/om/site/stop/exportPdf?id=' + record.id, {});
    }
  }
};